import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const Loading = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f7',
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: '#0071e3',
          mb: 3,
        }}
      />
      <Typography
        variant="h6"
        sx={{
          fontWeight: 500,
          color: '#1d1d1f',
          opacity: 0.8,
          letterSpacing: '-0.02em',
        }}
      >
        Loading...
      </Typography>
    </Box>
  );
};

export default Loading; 